export const translations = {
  en: {
    instructions: 'Please provide your insurance information:',
    label_name: 'Health Plan Name',
    label_id: 'Health Plan ID',
    label_number: 'Member Number/ID',
    label_group: 'Group Number/ID',
    label_street: 'Insurance Street',
    label_city: 'Insurance City',
    label_state: 'Insurance State',
    label_zip: 'Insurance Zip',
    label_relationship: 'Patient relationship to subscriber:',
    label_first_name: 'First name on card',
    label_middle_name: 'Middle name on card',
    label_last_name: 'Last name on card',
    error_name: 'Please enter Health Plan Name',
    error_id: 'Please enter Health Plan ID',
    error_number: 'Please enter Member Number/ID',
    error_street: 'Please enter Insurance Street',
    error_city: 'Please enter Insurance City',
    error_state: 'Please enter Insurance State',
    error_zip: 'Please enter Insurance Zip',
    error_valid_zip: 'Must be a valid zip',
    error_first_name: 'Please enter first name on card',
    error_last_name: 'Please enter Last name on card',
    error_16_characters: '16 characters maximum',
    error_20_characters: '20 characters maximum',
    error_26_characters: '26 characters maximum',
    error_30_characters: '30 characters maximum',
    error_34_characters: '34 characters maximum',
    error_100_characters: '100 characters maximum',
    error_only_digits: 'Must be only digits',
    error_invalid_char: 'No numbers or special characters or space allowed',
    placeholder_plan_name: 'Name of plan',
    placeholder_plan_id: 'Enter Health Plan ID',
    placeholder_plan_number: 'Enter Member Number/ID',
    placeholder_plan_group: 'Enter Group Number/ID',
    placeholder_address: 'Enter Address',
    placeholder_city: 'Enter Insurance City',
    placeholder_zip: 'Enter Insurance Zip',
    placeholder_first_name: 'Enter First Name',
    placeholder_middle_name: 'Enter Middle Name',
    placeholder_last_name: 'Enter Last Name'
  },
  es: {
    instructions: 'Por favor, proporcione la información de su seguro:',
    label_name: 'Nombre del plan de salud',
    label_id: 'Número del plan de salud',
    label_number: 'Número de miembro o identificación',
    label_group: 'Número de grupo o identificación',
    label_street: 'Dirección del seguro',
    label_city: 'Ciudad del seguro',
    label_state: 'Estado del seguro',
    label_zip: 'Código postal seguro',
    label_relationship: 'Relación del paciente con el suscriptor:',
    label_first_name: 'Primer nombre en la tarjeta',
    label_middle_name: 'Segundo nombre en la tarjeta',
    label_last_name: 'Apellido en la tarjeta',
    error_name: 'Por favor introduzca el nombre del plan de salud',
    error_id: 'Por favor introduzca el número del plan de salud',
    error_number: 'Por favor introduzca su Número/ID de miembro',
    error_street: 'Por favor introduzca la calle de su seguro',
    error_city: 'Por favor introduzca la ciudad de su seguro',
    error_state: 'Por favor seleccione el estado de su seguro',
    error_zip: 'Por favor introduzca código postal válido',
    error_valid_zip: 'Debe ser un código postal válido',
    error_first_name: 'Por favor introduzca el primer nombre en la tarjeta',
    error_last_name: 'Por favor introduzca el apellido en la tarjeta',
    error_16_characters: 'Por favor use 16 caracteres o menos',
    error_20_characters: 'Por favor use 20 caracteres o menos',
    error_26_characters: 'Por favor use 26 caracteres o menos',
    error_30_characters: 'Por favor use 30 caracteres o menos',
    error_34_characters: 'Por favor use 34 caracteres o menos',
    error_100_characters: 'Por favor use 100 caracteres o menos',
    error_only_digits: 'Deben ser sólo números',
    error_invalid_char: 'No se permiten números ni caracteres especiales ni espacios',
    placeholder_plan_name: 'Introduzca nombre del plan',
    placeholder_plan_id: 'Introduzca número del plan',
    placeholder_plan_number: 'Introduzca número de miembro',
    placeholder_plan_group: 'Introduzca número de grupo',
    placeholder_address: 'Introduzca dirección del seguro',
    placeholder_city: 'Introduzca ciudad del seguro',
    placeholder_zip: 'Código postal del seguro',
    placeholder_first_name: 'Introduzca primer nombre',
    placeholder_middle_name: 'Introduzca segundo nombre',
    placeholder_last_name: 'Introduzca apellido'
  }
};
